function on(eventType, listener, element) {
    off(eventType, listener,element);
    if(element){
        element.addEventListener(eventType, listener);
    }else{
        document.addEventListener(eventType, listener);
    }
    
}
  
function off(eventType, listener, element) {
    if(element){
        element.removeEventListener(eventType, listener);
    }else{
        document.removeEventListener(eventType, listener);
    }
    
}
  
function once(eventType, listener, element) {
    on(eventType, handleEventOnce, element);

    function handleEventOnce(event) {
        listener(event);
        off(eventType, handleEventOnce, element);
    }
}
  
function trigger(eventType, data) {
    const event = new CustomEvent(eventType, { detail: data });
    document.dispatchEvent(event);
}
  
export { on, once, off, trigger };